import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { CoreAutoTabDirective } from './auto-tab/auto-tab.directive';
import { CoreFreshdeskButtonDirective } from './freshdesk-button/freshdesk-button.directive';
import { CoreSizeMeDirective } from './size-me/size-me.directive';

import { CoreResizeDetectorService } from '@core/services/resize-detector.service';


@NgModule({
    declarations: [
        CoreFreshdeskButtonDirective,
        CoreAutoTabDirective,
        CoreSizeMeDirective
    ],
    exports: [
        CoreFreshdeskButtonDirective,
        CoreAutoTabDirective,
        CoreSizeMeDirective
    ],
    providers: [CoreResizeDetectorService],

})
export class CoreDirectives { }
